export const sellerConstants = {
  ADD_SELLER_REQUEST: "ADD_SELLER_REQUEST",
  ADD_SELLER_SUCCESS: "ADD_SELLER_SUCCESS",
  ADD_SELLER_FAILURE: "ADD_SELLER_FAILURE",
  ADD_SELLER_CLEAR: "ADD_SELLER_CLEAR",

  GET_SELLER_REQUEST: "GET_SELLER_REQUEST",
  GET_SELLER_SUCCESS: "GET_SELLER_SUCCESS",
  GET_SELLER_FAILURE: "GET_SELLER_FAILURE",

  GET_SELLERS_REQUEST: "GET_SELLERS_REQUEST",
  GET_SELLERS_SUCCESS: "GET_SELLERS_SUCCESS",
  GET_SELLERS_FAILURE: "GET_SELLERS_FAILURE",
};
